var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 2.33325C11.6927 2.33325 9.43709 3.01749 7.51851 4.29944C5.59994 5.58139 4.1046 7.40347 3.22157 9.53528C2.33855 11.6671 2.10751 14.0129 2.55767 16.276C3.00783 18.5391 4.11898 20.6179 5.75059 22.2495C7.3822 23.8811 9.461 24.9923 11.7241 25.4424C13.9872 25.8926 16.333 25.6615 18.4648 24.7785C20.5966 23.8955 22.4187 22.4001 23.7006 20.4816C24.9826 18.563 25.6668 16.3074 25.6668 13.9999C25.6668 12.4678 25.3651 10.9507 24.7788 9.53528C24.1925 8.11981 23.3331 6.83369 22.2497 5.75034C21.1664 4.66699 19.8803 3.80763 18.4648 3.22132C17.0493 2.63502 15.5323 2.33325 14.0002 2.33325V2.33325ZM3.78535 13.9999C3.77745 12.0441 4.33189 10.1273 5.38265 8.47774C6.4334 6.82818 7.93617 5.51541 9.71195 4.69582C11.4877 3.87623 13.4617 3.58435 15.3987 3.85496C17.3357 4.12557 19.154 4.94725 20.6372 6.22214L6.30017 20.7407C4.66697 18.8762 3.77246 16.4785 3.78535 13.9999V13.9999ZM14.0002 24.2018C11.5453 24.2037 9.17321 23.3147 7.32424 21.6999L21.7002 7.32399C22.9763 8.80038 23.8017 10.6122 24.078 12.544C24.3544 14.4759 24.0702 16.4464 23.2591 18.2214C22.4481 19.9964 21.1444 21.5011 19.503 22.5567C17.8616 23.6123 15.9517 24.1742 14.0002 24.1758V24.2018Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedArea);
export default __webpack_public_path__ + "static/media/restricted-area.c2af17f221046d124e539870cc6a07c0.svg";
export { ForwardRef as ReactComponent };